import { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Courses from './components/Courses';
import Contact from './components/Contact';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import TrialModal from './components/TrialModal';
import LoginModal from './components/LoginModal';

function App() {
  const [isTrialModalOpen, setIsTrialModalOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  // SEO and Analytics setup
  useEffect(() => {
    // Set page title and meta description
    document.title = 'SwarSadhana - Harmony in Every Note and Pose | Online Music, Yoga & Dance Classes';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content',
        'Learn Hindustani vocals, tabla, Hatha yoga, Bharatanatyam, and Bollywood dance with expert instructors. Live 1-on-1 classes for all ages. Start your journey today!'
      );
    }

    // Track page view
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('config', 'GA_MEASUREMENT_ID', {
        page_title: 'SwarSadhana Landing Page',
        page_location: window.location.href,
      });
    }
  }, []);

  const handleTrialClick = () => {
    setIsTrialModalOpen(true);

    // Track trial button click
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', 'trial_button_click', {
        event_category: 'engagement',
        event_label: 'header_cta',
      });
    }
  };

  const handleViewPlansClick = () => {
    const coursesSection = document.getElementById('courses');
    if (coursesSection) {
      coursesSection.scrollIntoView({ behavior: 'smooth' });
    }
    // Track view plans click
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', 'view_plans_click', {
        event_category: 'engagement',
        event_label: 'hero_cta',
      });
    }
  };

  const handleCloseTrialModal = () => {
    setIsTrialModalOpen(false);
  };

  const handleLoginClick = () => {
    setIsLoginModalOpen(true);
  };

  const handleCloseLoginModal = () => {
    setIsLoginModalOpen(false);
  };

  return (
    <Router>
      <div className="App">
        {/* Header */}
        <Header onLoginClick={handleLoginClick} />

        {/* Main Content */}
        <main>
          <Hero
            onTrialClick={handleTrialClick}
            onViewPlansClick={handleViewPlansClick}
          />
          <Features />
          <Courses onEnrollClick={handleTrialClick} />
          <Contact />
          <Testimonials />
        </main>

        {/* Footer */}
        <Footer />

        {/* Modals */}
        <TrialModal
          isOpen={isTrialModalOpen}
          onClose={handleCloseTrialModal}
        />
        <LoginModal
          isOpen={isLoginModalOpen}
          onClose={handleCloseLoginModal}
        />
      </div>
    </Router>
  );
}

export default App;
